import React, { useState } from 'react'
import { Box, Text, Input, ListItem, UnorderedList } from '@chakra-ui/react'
const OrderTags = ({ isTitle, savedTag }) => {
    const [tags, setTags] = useState(savedTag || []);
    const [inputValue, setInputValue] = useState("");

    
    // Adding and removing tags functionality
    const addTag = (tag) => {
        setTags((prevTags) => [...prevTags, tag]);
    }

    const removeTag = (index) => {
        setTags((prevTags) => prevTags.filter((_, i) => i !== index));
    }

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }

    const handleInputKeyDown = (event) => {
        if (event.key === "Enter" && inputValue.length > 0 && tags.length >= 0) {
            addTag(inputValue.trim());
            setInputValue("");
        }
        if (event.key === "Backspace" && inputValue.length === 0 && tags.length > 0) {
            removeTag(tags.length - 1);
        }
    }

    const handleTagClick = (index) => {
        removeTag(index);
    }

    const sanitizeTag = (tag) => {
        return tag.replace(/[^\w -]/g, "").trim().replace(/\W+/g, "-");
    }

    const handleInputBlur = () => {
        if (inputValue.length > 0) {
            addTag(sanitizeTag(inputValue));
            setInputValue("");
        }
    }

    return (
            <>
            
            <Box my={5} py={isTitle ? 3 : 0}>
            
                <UnorderedList display={'flex'} flexWrap={'wrap'} border={'1px solid rgba(0, 0, 0, 0.7)'} borderRadius={'3px'} px={2} py={3} m={0}>
                {!isTitle && <Text as={'span'} fontWeight={'semibold'}>Tags : &nbsp;</Text>}
                    {tags.map((renderTag, index) => {
                        return (
                            <ListItem display={'flex'} rounded={'md'} justifyContent={'space-between'} color={'white'} alignItems={'center'} listStyleType={'none'} key={index} mr={2} mb={2} px={4} py={4} h={'30px'} bgColor={'#3182ce'}>
                                {renderTag.title}
                                <Box as="button" ml={'10px'} onClick={() => handleTagClick(index)}>
                                    &times;
                                </Box>
                            </ListItem>
                        )
                    })}
                   
                    <Input
                        h={'30px'}
                        flex={1}
                        p={0}
                        border={'unset'}
                        outline={'unset'}
                        focusBorderColor="transparent"
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleInputKeyDown}
                        onBlur={handleInputBlur}
                    />
                </UnorderedList>
                {/* <Input value={inputValue} onChange={(e) => setInputValue(e.target.value)} onKeyDown={handleKeyDown}/> */}
            </Box>
            </>
    )
}

export default OrderTags